import { ViewModel,View } from "binder"
import { ExecutableViewModel } from "../../executable/executable-viewModel";
import { IExecutablePart, IExecutablePartVisitor } from "../executablePart";
import  { CallServerView } from "./callServer-view"

export class CallServerViewModel extends ViewModel implements IExecutablePart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.initializationCode = new ExecutableViewModel(this);
        this.settingCode = new ExecutableViewModel(this);
    }
    
    GetDefaultView(): View <ViewModel> {
        return new CallServerView();
    }
    public getTypeId(): string {
        return "VM-37A2A8D9-2A7E-491B-8416-F545D05A8548"
    }
    public set initializationCode(v: ExecutableViewModel) { this._initializationCode = v; } public get initializationCode(): ExecutableViewModel { return this._initializationCode;} private _initializationCode: ExecutableViewModel;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set settingCode(v: ExecutableViewModel) { this._settingCode = v; } public get settingCode(): ExecutableViewModel { return this._settingCode;} private _settingCode: ExecutableViewModel;
    public set inVariableName(v: string) { this._inVariableName = v; } public get inVariableName(): string { return this._inVariableName;} private _inVariableName: string;
    public set outVariableName(v: string) { this._outVariableName = v; } public get outVariableName(): string { return this._outVariableName;} private _outVariableName: string;
        
    accept(visitor: IExecutablePartVisitor, parameter: any):any {
        return visitor.VisitCallServer(this,parameter);
    }
}
